import Autosuggest from 'react-autosuggest';
import {useEffect, useState} from 'react';
import './autosuggest.css';

const getSuggestionValue = (suggestion) => suggestion.name;

const AutoSuggest = (props: {
  placeholder: string;
  getSuggestions: (v) => Promise<any[]>;
  onSuggestionSelected: (e: any, s: any) => void;
  renderSuggestion: (e) => any;
}) => {
  const [value, setValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);

  const onChange = (event, {newValue}) => setValue(newValue);
  const onSuggestionsFetchRequested = async ({value}) => setSuggestions(await props.getSuggestions(value));
  const onSuggestionsClearRequested = () => setSuggestions([]);

  const inputProps = {
    placeholder: props.placeholder,
    value,
    onChange,
  };

  useEffect(() => {
    (async () => {
      const res = await props.getSuggestions('');
      setSuggestions(res);
    })();
  }, []);

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      onSuggestionSelected={props.onSuggestionSelected}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={props.renderSuggestion}
      inputProps={inputProps}
    />
  );
};
export default AutoSuggest;
